// extracted by mini-css-extract-plugin
module.exports = {"section":"not-available-status_section__fOmcU","label":"not-available-status_label__KUjkk"};